const WHATSAPP_URL =
  'https://wa.me/905301714669?text=Merhaba%20SARA%20KUYUMCULUK%2C%20%C3%B6zel%20bir%20tasar%C4%B1m%20talep%20etmek%20istiyorum.';

export default function WhatsAppCTASection() {
  return (
    <section id="cta" className="w-full bg-luxury-black py-24 md:py-40 px-6 md:px-12 relative overflow-hidden">
      {/* Decorative gold glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div
          className="w-[600px] h-[600px] rounded-full opacity-10"
          style={{
            background:
              'radial-gradient(circle, #C9A057 0%, transparent 70%)',
          }}
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center">
        {/* Label */}
        <div className="reveal">
          <span className="font-sans text-gold text-xs tracking-luxury uppercase border border-gold/30 px-5 py-2 inline-block">
            Hemen Başla
          </span>
        </div>

        {/* Headline */}
        <h2 className="reveal reveal-delay-1 font-serif text-5xl sm:text-6xl md:text-7xl text-white font-light mt-10 leading-tight">
          Tasarımını
          <br />
          <em className="text-gold-gradient not-italic">Hemen Başlat</em>
        </h2>

        {/* Sub */}
        <p className="reveal reveal-delay-2 font-sans text-white/50 text-sm mt-6 max-w-md leading-loose">
          Hayal ettiğiniz takıyı bir mesaj uzağınızda. WhatsApp üzerinden bize yazın,
          tasarım sürecini birlikte yönetelim.
        </p>

        <div className="reveal reveal-delay-3 gold-line w-24 mt-10" />

        {/* Main CTA */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="nofollow noreferrer"
          className="reveal reveal-delay-4 btn-gold mt-10 px-12 py-5 text-sm rounded-sm whitespace-nowrap inline-flex items-center gap-4"
        >
          <i className="ri-whatsapp-line text-xl" />
          WhatsApp&apos;tan Yaz
        </a>

        {/* Supporting text */}
        <p className="reveal font-sans text-white/30 text-xs tracking-wide mt-6">
          Ücretsiz danışmanlık · Hızlı yanıt · Kişiye özel tasarım
        </p>

        {/* Gold divider bottom */}
        <div className="reveal gold-line w-full max-w-lg mt-16" />

        {/* Footer bar */}
        <div className="reveal mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 w-full max-w-lg">
          <p className="font-sans text-white/20 text-xs tracking-wide">
            © 2024 SARA KUYUMCULUK. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="nofollow noreferrer"
              className="text-white/30 hover:text-gold transition-colors cursor-pointer"
              aria-label="WhatsApp"
            >
              <i className="ri-whatsapp-line text-lg" />
            </a>
            <a
              href="https://www.instagram.com/sara.kuyumculuk"
              target="_blank"
              rel="nofollow noreferrer"
              className="text-white/30 hover:text-gold transition-colors cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
